import { CheckCircle, Phone, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ThankYou = () => {
  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center space-y-8">
        {/* Success Icon */}
        <div className="w-20 h-20 rounded-full bg-green/20 flex items-center justify-center mx-auto">
          <CheckCircle className="w-10 h-10 text-green" />
        </div>

        {/* Heading */}
        <div className="space-y-4">
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-white">
            Děkuji za váš zájem!
          </h1>
          <p className="text-gray-400 text-lg">
            Váš finanční plán je na cestě. Zkontrolujte svůj email.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://pancungradi.simplybook.it/v2/#book"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="thankyou-booking-btn"
            className="btn-gold flex items-center justify-center gap-2"
          >
            <Phone className="w-5 h-5" />
            Rezervovat konzultaci
          </a>
          <Link to="/" data-testid="thankyou-home-btn" className="btn-outline flex items-center justify-center gap-2">
            <ArrowLeft className="w-5 h-5" />
            Zpět na kalkulačky
          </Link>
        </div>
      </div>
    </div>
  );
};
